export const SEPHORA_PAGE_TYPE = 'sephoraProduct';

export const SEPHORA_ALREADY_REGISTERED_ERROR = 'This Email Has Already Associated With Another Account';

export const SEPHORA_ALREADY_LINKED_ERROR = 'The Account has already linked';

export const SEPHORA_MISSING_ACCOUNT_ERROR = 'Customer Lookup Missing Account';

export const SEPHORA_INVALID_OTP = 'Invalid OTP';

export const SEPHORA_RETURN_WINDOW_LENGTH_IN_DAYS = 30;

export const SEPHORA_BRAND_ID = '6608';

export const SEPHORA_VENDOR_CODE = 'VU6YE';

export const SEPHORA_PRIVACY_POLICY_LINK = 'https://www.sephora.com/beauty/privacy-policy';

export const SEPHORA_FINANCIAL_INCENTIVE_LINK = 'https://www.sephora.com/beauty/privacy-policy#USNoticeIncentive';

export const SEPHORA_TERMS_OF_USE_LINK = 'https://www.sephora.com/beauty/terms-of-use';

export const SEPHORA_BI_TERMS_OF_USE_LINK = 'https://www.sephora.com/beauty/terms-conditions-beauty-insider';
